import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

// Attach token from localStorage if present
api.interceptors.request.use((cfg) => {
  const token = localStorage.getItem("vsdi_token");
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

export function pct(v) {
  return `${Math.round((v || 0) * 100)}%`;
}

export function statusColor(s) {
  return {
    overload: "bg-red-500",
    underload: "bg-amber-500",
    optimal: "bg-emerald-500",
    unassigned: "bg-slate-400",
  }[s] || "bg-slate-300";
}

export function statusBadge(s) {
  const label = {
    overload: "Overloaded",
    underload: "Underloaded",
    optimal: "Optimal",
    unassigned: "Not Assigned",
  }[s] || "—";
  const color = {
    overload: "bg-red-100 text-red-800 border-red-300",
    underload: "bg-amber-100 text-amber-800 border-amber-300",
    optimal: "bg-emerald-100 text-emerald-800 border-emerald-300",
    unassigned: "bg-slate-100 text-slate-700 border-slate-300",
  }[s] || "bg-slate-100 text-slate-700";
  return { label, color };
}

export const euro = (v) =>
  new Intl.NumberFormat("en-US", { style: "currency", currency: "EUR", maximumFractionDigits: 0 }).format(v || 0);

// Rolling 3-month labels starting from today.
// The DB fields are always keyed as apr/may/jun (positional columns from the Excel),
// but here we translate them into "Current, Current+1, Current+2" using the current calendar month.
// Example: if today is May 2026 → ["May", "Jun", "Jul"] → mapped to fields [apr, may, jun]
export function rollingMonthLabels(count = 3) {
  const now = new Date();
  const labels = [];
  for (let i = 0; i < count; i++) {
    const d = new Date(now.getFullYear(), now.getMonth() + i, 1);
    labels.push(d.toLocaleString("en-US", { month: "short" }));
  }
  return labels;
}

// The 3 DB field keys in fixed order (do NOT change — these mirror parser output).
export const MONTH_KEYS = ["apr", "may", "jun"];

// Rolling period label like "Aug–Oct 2026" — derived from rollingMonthLabels().
// Spans a year boundary correctly (e.g. "Dec 2026–Feb 2027").
export function rollingPeriodLabel(count = 3) {
  const now = new Date();
  const first = new Date(now.getFullYear(), now.getMonth(), 1);
  const last = new Date(now.getFullYear(), now.getMonth() + count - 1, 1);
  const m = (d) => d.toLocaleString("en-US", { month: "short" });
  if (first.getFullYear() === last.getFullYear()) {
    return `${m(first)}–${m(last)} ${first.getFullYear()}`;
  }
  return `${m(first)} ${first.getFullYear()}–${m(last)} ${last.getFullYear()}`;
}
